import { Box, BoxProps, TextNew } from '@jfs/ui-new'
import { NavigationContainer } from '@react-navigation/native'
import { createStackNavigator } from '@react-navigation/stack'
import { Suspense, lazy } from 'react'
import { ErrorModal } from '../components/ErrorModal'
import { FallbackScreen } from '../components/FallbackScreen'
import { Toast } from '../components/Toast'
import { useStores } from '../data/store'
import DrawerScreen from '../screens/dashboard'
import { navigationRef } from './NavService'

const Login = lazy(() => import('../screens/Login/'))
const styles = {
  container: {
    height: '100vh',
    width: '100%',
    justifyContent: 'center',
  } as BoxProps,
}
const Stack = createStackNavigator()
const { REACT_APP_ENDPOINT = '' } = window?._env_
const linking = {
  prefixes: ['https://localhost.com', 'localhost://'],
  config: {
    screens: {
      login: `${REACT_APP_ENDPOINT}/login`,
      dashboard: {
        path: REACT_APP_ENDPOINT,
        screens: {
          fAndRAction: {
            screens: {
              riskHoldable: 'fAndRAction/riskHoldable',
              riskHold: 'fAndRAction/riskHold',
              limitHold: 'fAndRAction/limitHold',
            },
          },
          fAndRAudit: {
            screens: {
              riskHoldableAudit: 'fAndRAudit/riskHoldableAudit',
              riskHoldAudit: 'fAndRAudit/riskHoldAudit',
              limitHoldAudit: 'fAndRAudit/limitHoldAudit',
            },
          },
        },
      },
    },
  },
}
const AppStack = () => {
  const { errorMessage, resetMessage, updateSession, serviceError, resetServiceError, updateIsCitrixIp } = useStores(
    (root) => ({
      errorMessage: root.message.getMessage(),
      resetMessage: root.message.resetMessage,
      setSession: root.user.setSession,
      updateSession: root.session.updateAllSessionData,
      serviceError: root.serviceError.getServiceError(),
      resetServiceError: root.serviceError.resetServiceError,
      updateIsCitrixIp: root.session.updateIsCitrixIp,
    }),
  )

  const isSessionValid = (data: any) => {
    return (
      !!data?.appAccessToken &&
      !!data.appRefreshToken &&
      !!data.appIdToken &&
      !!data.usrAccessToken &&
      !!data.usrRefreshToken &&
      !!data.usrIdentifierToken
    )
  }

  const getRoute = () => {
    const sDataCitrix = localStorage.getItem('isCitrixIp')
    updateIsCitrixIp(sDataCitrix)
    const sData = localStorage.getItem('sessionData')
    const sObj = JSON.parse(sData!)
    if (sData !== null && sData.length > 0 && isSessionValid(sObj)) {
      const jsonValue = JSON.parse(sData)
      updateSession(jsonValue)
      return 'dashboard'
    }
    return 'login'
  }

  const handleErrorDismiss = () => {
    resetServiceError()
  }

  return (
    <Box {...styles.container}>
      <Suspense fallback={<FallbackScreen />}>
        <NavigationContainer
          ref={navigationRef}
          linking={linking}
          documentTitle={{ formatter: () => 'JioPay Services' }}
          onStateChange={(state) => {}}
          fallback={<TextNew>Loading...</TextNew>}
          independent={true}>
          <Stack.Navigator initialRouteName={getRoute()} screenOptions={{ headerShown: false }}>
            <Stack.Screen name="login" component={Login} />
            <Stack.Screen name="dashboard" component={DrawerScreen} />
          </Stack.Navigator>
        </NavigationContainer>
      </Suspense>
      <ErrorModal
        show={serviceError?.message?.length > 0}
        errorMessage={serviceError?.message}
        errorTitle={serviceError?.title}
        traceId={serviceError?.traceId}
        serviceName={serviceError?.serviceName}
        onDismiss={handleErrorDismiss}
      />
      <Toast
        message={errorMessage.value}
        hide={errorMessage.value === ''}
        position={errorMessage?.code === '999' ? 'TOP' : 'BOTTOM'}
        type={errorMessage.type}
        onDismiss={() => {
          resetMessage()
        }}
        testID={'toast'}
        code={errorMessage?.code}
      />
    </Box>
  )
}

export { AppStack }
